import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/clientCrateType'

const clientCrateType = axios.create({
  baseURL
})

interceptorsSetup(clientCrateType)

export default class ClientCrateType {
  static async getAll () {
    const result = await clientCrateType.get('/')
    return result.data
  }

  // The types one plant can see — what the declaration forms build their crate type
  // lists from.
  static async getForSite (siteId) {
    const result = await clientCrateType.get('/site/' + siteId)
    return result.data
  }

  static async create (type) {
    const result = await clientCrateType.post('/', type)
    return result.data
  }

  static async update (type) {
    const result = await clientCrateType.post('/update', type)
    return result.data
  }

  static async archive (id) {
    const result = await clientCrateType.put('/archive/' + id)
    return result.data
  }
}
